import styled from 'styled-components';
import { media } from '../../../../style/media';

export const ContentContainer = styled.div`
  padding: 24px 32px;
  width: 100%;

  ${media.m`
    padding: 16px 12px;
    overflow-x: auto;
  `}

  ${media.s`
    padding: 12px 8px;
    overflow-x: auto;
  `}
`;

